import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const Card = React.forwardRef((props, ref) => {
    const { className = 'iv-bg-black-4 iv-rounded-3xl iv-overflow-hidden', children, ...args } = props;
    return (_jsx("div", { className: `${className}`, ...args, children: children }));
});
export default Card;
